import axios from '@/axiosInterceptor';
import _ from 'lodash';

const state = () => {
  return {
    payment_body: null,
    secondVerificationPayment: false,
    activePaymentMethods: [],
    activePaymentMethodsHaveLoaded: false,
    payment_type: '',
    payment_term_id: '',
    saved_payment_term: null,
    edit: {
      factor: false,
      payment_method: false,
    },
    payment_source: '',
    saved_payment_method: null,
    verification_code: '',
    errors: false,
    latest_payment_method: null,
    latest_allowed_payment_method: null,
    latest_triumph_pay_payment_method: null,
    rendered_payment: null,
    payment_terms: [],
    paymentTermsHaveLoaded: false,
    triumph_pay_declined: false,
    selected_payment_term: null,
    displayed_payment_method: null,
    possible_payment_methods: [
      'triumph_pay',
      'ach',
      'check',
      'cad_eft',
      'wire',
      'comcheck',
      'efs',
      'echeck',
    ],
    carrierAPMs: [],
    carrierAPMsHaveLoaded: false,
    newPaymentMethodType: null,
    loadPayWasDeselected: false,
  };
};

const getters = {};

// actions

const actions = {
  async setPaymentBody({ commit }, body) {
    commit('setPaymentData', { data: body, type: 'payment_body' });
  },
  async createPaymentMethod(
    { commit, rootState },
    { paymentMethod, onboardingPacketId }
  ) {
    try {
      let res = await axios.post(
        process.env.API_IDENTITY + '/api/v1/payment_methods',
        paymentMethod
      );

      let onboardingPacketBody = {
        onboarding_packet: {
          payment_method_id: res?.data?.id,
        },
      };

      let onboardingRes = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets/' +
          onboardingPacketId,
        onboardingPacketBody
      );
      commit(
        'carriers/setCarrierData',
        { ...rootState.carriers.carrierData, ...onboardingRes.data },
        { root: true }
      );
      commit('setPaymentData', { data: res.data, type: 'payment_method' });
      commit('setPaymentData', { data: {}, type: 'ch' });
      commit('resetEdit');

      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        if (
          status === 422 &&
          e?.response?.data?.payment_method?.[0] ==
            'verification required for adding additional payment methods'
        ) {
          console.log(
            '422 error on create payment - need to send to verification (Payment-4)'
          );
          // console.dir(e);
          // await commit("setVerificationSecond", true);
        }
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getLatestPaymentMethod({ commit, rootState, state }) {
    let dispatcherQuery = '';
    if (rootState?.users?.currentUser?.company?.company_type == 'dispatcher') {
      const receiverId =
        rootState?.carriers?.carrierData?.connection?.receiver_id;
      dispatcherQuery = `&q[company_id_eq]=${receiverId}`;
    }
    let queryParams = `payment_methods?q[is_active_true]=1&page=1&per_page=1${dispatcherQuery}&q[s]=id desc`;
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/' + queryParams
      );
      if ([200, 201].includes(res?.status)) {
        if (!state?.latest_payment_method) {
          commit('setLatestPaymentMethod', res?.data);
        }
      }
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getLatestTriumphPayPaymentMethod({ commit, rootState }) {
    let dispatcherQuery = '';
    if (rootState?.users?.currentUser?.company?.company_type == 'dispatcher') {
      const receiverId =
        rootState?.carriers?.carrierData?.connection?.receiver_id;
      dispatcherQuery = `&q[company_id_eq]=${receiverId}`;
    }
    let queryParams = `payment_methods?q[is_active_true]=1&q[is_type_eq]=triumph_pay&page=1&per_page=1${dispatcherQuery}&q[s]=id desc`;
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/' + queryParams
      );
      if ([200, 201].includes(res?.status)) {
        commit('setLatestTriumphPayPaymentMethod', res?.data?.[0]);
      }
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getLatestAllowedPaymentMethod(
    { commit, state, rootState },
    payment_term
  ) {
    let dispatcherQuery = '';
    if (rootState?.users?.currentUser?.company?.company_type == 'dispatcher') {
      const receiverId =
        rootState?.carriers?.carrierData?.connection?.receiver_id;
      dispatcherQuery = `&q[company_id_eq]=${receiverId}`;
    }
    let payment_term_apms = payment_term?.allowed_payment_methods;
    if (payment_term_apms?.length > 0) {
      let paymentMethodsQuery = payment_term_apms
        .map((payment_method) => `q[is_type_in][]=${payment_method}`)
        .join('&');
      let queryParams =
        'payment_methods?q[is_active_true]=1&' +
        paymentMethodsQuery +
        dispatcherQuery +
        '&q[s]=id desc';

      // console.log('getLatestAllowedPaymentMethod queryParams: ', queryParams);
      try {
        let res = await axios.get(
          process.env.API_IDENTITY + '/api/v1/' + queryParams
        );
        if ([200, 201].includes(res?.status)) {
          let results = res?.data;
          if (results?.length > 1) {
            // Default to Triumph Pay if available
            if (payment_term_apms?.includes('triumph_pay')) {
              let apm = [...state.activePaymentMethods];
              let triumph_pay = apm.find(
                (payment_method) => payment_method?.is_type === 'triumph_pay'
              );
              if (triumph_pay?.length > 0) {
                commit('setLatestAllowedPaymentMethod', triumph_pay);
              } else {
                commit('setLatestAllowedPaymentMethod', results[0]);
              }
            } else {
              commit('setLatestAllowedPaymentMethod', results[0]);
            }
          } else if (results?.length === 1) {
            commit('setLatestAllowedPaymentMethod', results[0]);
          } else {
            console.log('no existing payment methods found');
          }
        }
        return res;
      } catch (e) {
        let status = e?.response?.status;
        if (
          axios.isAxiosError(e) &&
          status &&
          [401, 403, 404, 422].includes(status)
        ) {
          return e?.response;
        } else {
          throw e;
        }
      }
    } else {
      console.log('payment_term_apms is empty');
    }
  },
  async getPaymentTerms({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets/' +
          id +
          '/payment_terms'
      );
      let type = 'payment_terms';
      let data = res?.data;

      data.forEach(function (paymentTerm) {
        if (paymentTerm?.is_type !== 'factoring')
          paymentTerm.allowed_payment_methods ||= ['check', 'ach'];
      });

      commit('setPaymentData', { data, type });
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getActivePaymentMethods({ commit, rootState }) {
    try {
      /* If the user is a dispatcher, we need to get the receiver_id from the carrierData connection 
         to ensure that payment methods for the dispatcher's other carrier connections are not shown */
      if (
        rootState?.users?.currentUser?.company?.company_type == 'dispatcher'
      ) {
        const receiverId =
          rootState?.carriers?.carrierData?.connection?.receiver_id;
        const res = await axios.get(
          `${process.env.API_IDENTITY}/api/v1/payment_methods?q[is_active_true]=1&q[company_id_eq]=${receiverId}&q[s]=id desc`
        );
        commit('setActivePaymentMethods', res?.data);
        return res;
      } else {
        const res2 = await axios.get(
          `${process.env.API_IDENTITY}/api/v1/payment_methods?q[is_active_true]=1&q[s]=id desc`
        );
        commit('setActivePaymentMethods', res2?.data);
        return res2;
      }
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getCarrierAPMsByTerm({ commit, rootState }, payment_term) {
    let payment_term_apms = payment_term?.allowed_payment_methods;
    let paymentMethodsQuery;
    let queryParams;
    let companyParam = '';

    if (payment_term_apms?.length > 0) {
      /* If the user is a dispatcher, we need to get the receiver_id from the carrierData connection 
         to ensure that payment methods for the dispatcher's other carrier connections are not shown */
      if (
        rootState?.users?.currentUser?.company?.company_type == 'dispatcher'
      ) {
        const receiverId =
          rootState?.carriers?.carrierData?.connection?.receiver_id;
        companyParam = 'q[company_id_eq]=' + receiverId + '&';
      }
      paymentMethodsQuery = payment_term_apms
        .map((payment_method) => `q[is_type_in][]=${payment_method}`)
        .join('&');
      queryParams =
        'payment_methods?q[is_active_true]=1&' +
        companyParam +
        paymentMethodsQuery +
        '&q[s]=id desc';

      try {
        let res = await axios.get(
          process.env.API_IDENTITY + '/api/v1/' + queryParams
        );
        if ([200, 201].includes(res?.status)) {
          commit('setCarrierAPMs', res?.data);
        } else {
          commit('setCarrierAPMs', []);
        }
        return res;
      } catch (e) {
        let status = e?.response?.status;
        if (
          axios.isAxiosError(e) &&
          status &&
          [401, 403, 404, 422].includes(status)
        ) {
          return e?.response;
        } else {
          throw e;
        }
      }
    } else {
      commit(
        'addFormDebugMessage',
        "ERROR | VUEX | onboardingPacket.js: 'getCarrierAPMsByTerm' called but the payment term parameter has no allowed_payment_methods",
        { root: true }
      );
    }
  },
  async sendVerificationCode({ commit }, { isEmailRequired = false }) {
    try {
      let verification_body = {
        verification: {
          channel: isEmailRequired ? 'email' : 'sms',
          verifiable_type: 'PaymentMethod',
        },
      };
      let res = await axios.post(
        process.env.API_IDENTITY + '/api/v1/verifications',
        verification_body
      );
      let type = 'verification_id';
      let data = res?.data?.id;
      commit('setPaymentData', { data, type });
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  //eslint-disable-next-line
  async verifyPaymentCode({ commit }, { verification_id, code }) {
    try {
      let verification_body = { code };
      let res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/verifications/' +
          verification_id +
          '/verify',
        verification_body
      );
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async getBankName(_, id) {
    try {
      let res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/routing_numbers/${id}`
      );
      return res;
    } catch (e) {
      const status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
  async updateNestedField({ commit }, { path, value }) {
    commit('updateNestedField', { path, value });
  },
  async storeNewPaymentMethodType({ commit }, type) {
    await commit('setNewPaymentMethodType', type);
  },
  async nullifySavedPaymentMethod({ commit }) {
    await commit('setPaymentData', {
      data: null,
      type: 'saved_payment_method',
    });
  },
};

//mutations
const mutations = {
  setPaymentData(state, { data, type }) {
    state[type] = data;
    if (type == 'payment_terms') {
      state.paymentTermsHaveLoaded = true;
    }
  },
  setTriumphPayDeclined(state, bool) {
    state.triumph_pay_declined = bool;
  },
  setReview(state) {
    state.edit.payment_method = false;
  },
  setVerificationSecond(state, value) {
    state.secondVerificationPayment = value;
  },
  setLatestPaymentMethod(state, value) {
    state.latest_payment_method = value;
  },
  setLatestAllowedPaymentMethod(state, value) {
    state.latest_allowed_payment_method = value;
  },
  setLatestTriumphPayPaymentMethod(state, value) {
    state.latest_triumph_pay_payment_method = value;
  },
  setActivePaymentMethods(state, value) {
    state.activePaymentMethods = value;
    // console.log('activePaymentMethods set: ', value);
    state.activePaymentMethodsHaveLoaded = true;
  },
  updateNestedField(state, { path, value }) {
    _.set(state, path, value);
  },
  setRenderedPayment(state, value) {
    state.rendered_payment = value;
  },
  setPaymentType(state, { paymentTerm, paymentTermId }) {
    state.payment_type = paymentTerm;
    state.payment_term_id = paymentTermId;
  },
  setEditFactor(state, bool) {
    state.edit.factor = bool;
  },
  setEditPaymentMethod(state, bool) {
    state.edit.payment_method = bool;
  },
  setPaymentSource(state, value) {
    console.log('setting payment source: ', value);
    state.payment_source = value;
  },
  resetEdit(state) {
    state['edit'] = {
      factor: false,
      check_ach: false,
    };
  },
  setSelectedPaymentTerm(state, value) {
    state.selected_payment_term = value;
  },
  setSavedPaymentMethod(state, value) {
    state.saved_payment_method = value;
  },
  setDisplayedPaymentMethod(state, value) {
    state.displayed_payment_method = value;
  },
  setCarrierAPMs(state, data) {
    state.carrierAPMs = data;
    state.carrierAPMsHaveLoaded = true;
  },
  setNewPaymentMethodType(state, value) {
    state.newPaymentMethodType = value;
    state.payment_source = value;
  },
  setLoadPayWasDeselected(state, value) {
    state.loadPayWasDeselected = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
